import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface StarsProps {
  value: number;
  size?: number;
  className?: string;
  onChange?: (v: number) => void;
}

export const Stars = ({ value, size = 14, className, onChange }: StarsProps) => {
  const rounded = Math.round((value ?? 0) * 2) / 2;
  const interactive = !!onChange;
  return (
    <div className={cn("inline-flex items-center gap-0.5", className)}>
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = rounded >= i;
        const half = !filled && rounded >= i - 0.5;
        const Icon = (
          <span className="relative inline-block" style={{ width: size, height: size }}>
            <Star
              className="absolute inset-0 text-amber-400"
              style={{ width: size, height: size }}
              fill={filled ? "currentColor" : "none"}
              strokeWidth={1.5}
            />
            {half && (
              <span className="absolute inset-0 overflow-hidden" style={{ width: size / 2 }}>
                <Star
                  className="text-amber-400"
                  style={{ width: size, height: size }}
                  fill="currentColor"
                  strokeWidth={1.5}
                />
              </span>
            )}
          </span>
        );
        if (interactive) {
          return (
            <button
              key={i}
              type="button"
              onClick={() => onChange?.(i)}
              className="transition-transform hover:scale-110"
              aria-label={`Rate ${i} stars`}
            >
              {Icon}
            </button>
          );
        }
        return <span key={i}>{Icon}</span>;
      })}
    </div>
  );
};
